<template>
    <div>
        <div class="con-search">
            <div class="search-station">
                <Icon icon="carbon:search" class="icon" /><input v-model="searchStation" placeholder="Search for station"
                    class="search-input">
            </div>

        </div>
        <GmapMap ref="mapRef" :center="center" :zoom="zoom" class="map-frame" :options="mapOptions"
            @click="resetMarkerIndex()">

            <GmapMarker :key="index" v-for="(station, index) in filteredStations"
                :position="(index, { lat: parseFloat(station.lat), lng: parseFloat(station.lng) })" :icon="{
                    url: customMarkerIcon, scaledSize: index === selectedMarkerIndex ? { width: 65, height: 70 } : { width: 55, height: 60 },
                }" @click="showInfoWindow(index, { lat: parseFloat(station.lat), lng: parseFloat(station.lng) })"
                :opened="infoWindow" />


        </GmapMap>

        <div class="card-stations" v-if="isCardStationVisible">
            <!-- <CardStation :marker-index="selectedMarkerIndex" :station="station_list"></CardStation> -->
            <CardStation :station="selectedStation"></CardStation>
        </div>
    </div>
</template>

<script>
import { gmapApi } from 'vue2-google-maps'
import { Icon } from '@iconify/vue2'
import CardStation from '../components/CardStation.vue';


export default {
    name: "Map",
    components: {
        CardStation,
        Icon
    },
    props: ['stationList'],
    data() {
        return {
            searchStation: "",
            station_list: [],
            station_active_list: [],
            center: { lat: 13.7563, lng: 100.5018 },
            zoom: 10,
            infoWindow: false,
            infoWindowPosition: null,
            selectedMarkerIndex: null,
            isCardStationVisible: false,
            customMarkerIcon: require("../assets/Marker.png"),
            mapOptions: {
                zoomControl: false,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                styles: [
                    {
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#616161"
                            }
                        ]
                    },
                    {
                        "elementType": "labels.text.stroke",
                        "stylers": [
                            {
                                "color": "#f5f5f5"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.land_parcel",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.land_parcel",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#bdbdbd"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.locality",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "administrative.neighborhood",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#eeeeee"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels.text",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#757575"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.business",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e5e5e5"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#c0e4cb"
                            }
                        ]
                    },
                    {
                        "featureType": "poi.park",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#ffffff"
                            }
                        ]
                    },
                    {
                        "featureType": "road",
                        "elementType": "labels.icon",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.arterial",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#757575"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#dadada"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#fef7e0"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "geometry.stroke",
                        "stylers": [
                            {
                                "color": "#ffd48a"
                            }
                        ]
                    },
                    {
                        "featureType": "road.highway",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#616161"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "road.local",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    },
                    {
                        "featureType": "transit",
                        "stylers": [
                            {
                                "visibility": "off"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.line",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#e5e5e5"
                            }
                        ]
                    },
                    {
                        "featureType": "transit.station",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#eeeeee"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "stylers": [
                            {
                                "color": "#9bc0f9"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry",
                        "stylers": [
                            {
                                "color": "#c9c9c9"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "geometry.fill",
                        "stylers": [
                            {
                                "color": "#c9defd"
                            }
                        ]
                    },
                    {
                        "featureType": "water",
                        "elementType": "labels.text.fill",
                        "stylers": [
                            {
                                "color": "#9e9e9e"
                            }
                        ]
                    }
                ]
            },
        }
    },
    methods: {
        showInfoWindow(index, { lat, lng }) {
            this.infoWindow = !this.infoWindow;
            this.infoWindowPosition = { lat: lat, lng: lng };
            this.selectedMarkerIndex = index;
            this.isCardStationVisible = true;
            // this.center = { lat: lat - 0.003, lng: lng };
            this.station_list = this.stationList.filter(station => {
                return station.name.toLowerCase().includes(this.searchStation.toLowerCase());
            });

            this.$nextTick(() => {
                this.$refs.mapRef.$mapPromise.then((map) => {
                    map.panTo({ lat: lat - 0.003, lng: lng })
                })
            })
        },
        resetMarkerIndex() {
            this.isCardStationVisible = false;
            this.selectedMarkerIndex = null;
            const { lat, lng } = this.center;
            // this.center = { lat: lat - 0.000001, lng: lng };
        },
        closeStation() {
            this.isCardStationVisible = false;
        },
        // searchStations() {
        //     if (!this.searchStation) {
        //         return this.station = this.stationList;
        //     } else {
        //         return this.stationList.filter(station => {
        //             return station.name.toLowerCase().includes(this.searchStation.toLowerCase());
        //         });
        //     }
        // }
    },
    computed: {
        filteredStations() {
            if (!this.searchStation) {
                return this.stationList;
            } else {
                return this.stationList.filter(station => {
                    return station.name.toLowerCase().includes(this.searchStation.toLowerCase());
                });
            }
        },
        selectedStation() {
            return this.filteredStations[this.selectedMarkerIndex];
        }
    },
}
</script>


<style>
.map-frame {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 10;
}

.card-stations {
    position: absolute;
    width: 100%;
    bottom: 50px;
}

.con-search {
    position: absolute;
    top: 40px;
    display: flex;
    width: 100%;
    z-index: 20;
    padding: 0 20px;
}

.search-input {
    width: 100%;
    margin-left: 10px;
    font-size: 14px;
}

.search-input:focus {
    outline: none;
}

.search-station {
    width: 100%;
    display: flex;
    align-items: center;
    justify-items: center;
    background: #fff;
    border-radius: 16px;
    padding: 8px 16px;
}

.icon {
    font-size: 24px;
}
</style>